import { render, staticRenderFns } from "./TranslationSection.vue.js?vue&type=template&id=e0476aa2!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TranslationSection.vue?vue&type=template&id=e0476aa2"
import script from "./TranslationSection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TranslationSection.vue?vue&type=script&lang=js"
export * from "./TranslationSection.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TranslationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports